export default __webpack_public_path__ + "static/media/wee_product_tag_line.1a8f23ac.svg";